import { AppStore } from "@/store/AppStore";
import { SessionEventModelData } from "@/store/sessions/types";
import Dexie from "dexie";

/**
 * Bounded variant of searchSessionEventsForSession: newest `limit` events for
 * a session. The unbounded query is fine for short-lived sessions but not for
 * an immortal thread (floating agent), which accumulates history forever.
 * Skips the feedback join — callers that need feedback_given use the
 * unbounded search.
 */
export const searchSessionEventsForSessionWindowed = async ({
  store,
  sessionId,
  limit,
}: {
  store: AppStore;
  sessionId: string;
  limit: number;
}): Promise<SessionEventModelData[]> => {
  const events = await store.sessionEvents.localTable
    .where("[session_id+locally_created_at+model_id]")
    .between([sessionId, Dexie.minKey], [sessionId, Dexie.maxKey])
    .reverse()
    .limit(limit)
    .toArray();

  return events.map(event => event.model_data);
};
